import React, { useState } from 'react';
import './ContactForm.css';

function ContactForm() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const [errors, setErrors] = useState<Record<string, string>>({});

    const validateForm = () => {
        let errors: Record<string, string> = {};
        let isValid = true;

        if (!formData.name.trim()) {
            errors.name = 'Please enter your name';
            isValid = false;
        }

        if (!formData.email.trim()) {
            errors.email = 'Please enter your email';
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = 'Please enter a valid email address';
            isValid = false;
        }

        if (!formData.subject.trim()) {
            errors.subject = 'Please enter a subject';
            isValid = false;
        }

        if (!formData.message.trim()) {
            errors.message = 'Please enter your message';
            isValid = false;
        }

        setErrors(errors);
        return isValid;
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validateForm()) {
            const successMsg = document.getElementById("success");
            if (successMsg) successMsg.innerHTML = "✔ Message Sent Successfully!";
            console.log('Form submitted successfully');
            setFormData({
                name: '',
                email: '',
                subject: '',
                message: ''
            });
        } else {
            const successMsg = document.getElementById("success");
            if (successMsg) successMsg.innerHTML = "";
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    return (
        <div className="contact-section py-5">
            <div className="container">
                <div className="section-header text-center mb-5">
                    <span className="pill-title">&bull; GET IN TOUCH</span>
                    <h2 className="display-4 font-weight-bold text-black" style={{ fontFamily: 'Cormorant Garamond, serif' }}>We'd Love to Hear From You</h2>
                    <p className="lead text-muted">Have a question or want to join our mission? Reach out to us directly.</p>
                </div>

                <div className="row g-5">
                    {/* Contact Info Cards */}
                    <div className="col-lg-5">
                        <div className="contact-info-wrap">
                            <div className="contact-card">
                                <div className="contact-card-icon">
                                    <i className="fas fa-map-marker-alt"></i>
                                </div>
                                <div className="contact-card-text">
                                    <h4>Our Location</h4>
                                    <p>Cape Coast, Central Region, Ghana</p>
                                </div>
                            </div>

                            <a href="tel:+233249664539" className="contact-card active-card">
                                <div className="contact-card-icon">
                                    <i className="fas fa-phone-alt"></i>
                                </div>
                                <div className="contact-card-text">
                                    <h4>Call Us</h4>
                                    <p>+233 24 966 4539</p>
                                </div>
                            </a>

                            <a href="https://wa.me/233249664539" target="_blank" rel="noopener noreferrer" className="contact-card active-card whatsapp">
                                <div className="contact-card-icon">
                                    <i className="fab fa-whatsapp"></i>
                                </div>
                                <div className="contact-card-text">
                                    <h4>WhatsApp</h4>
                                    <p>Chat with us directly</p>
                                </div>
                            </a>

                            <a href="mailto:showbouysfoundationlbg20@gmail.com" className="contact-card active-card">
                                <div className="contact-card-icon">
                                    <i className="fas fa-envelope"></i>
                                </div>
                                <div className="contact-card-text">
                                    <h4>Email Us</h4>
                                    <p>showbouysfoundationlbg20@gmail.com</p>
                                </div>
                            </a>

                            <div className="social-connect mt-4 pt-4 border-top">
                                <h5>Follow Our Journey</h5>
                                <div className="social-links-grid mt-3">
                                    <a href="https://www.facebook.com/share/1AQ51dzgeD/" target="_blank" rel="noopener noreferrer" className="social-link facebook">
                                        <i className="fab fa-facebook-f"></i>
                                    </a>
                                    <a href="https://www.instagram.com/showbouysfoundationlbg?igsh=MWEyeWNqZTdpeGJreg==" target="_blank" rel="noopener noreferrer" className="social-link instagram">
                                        <i className="fab fa-instagram"></i>
                                    </a>
                                    <a href="#" className="social-link x-twitter">
                                        <i className="fab fa-x-twitter"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="col-lg-7">
                        <div className="contact-form-card shadow-sm">
                            <div className='sent text-success mb-3' id="success"></div>
                            <form name="sentMessage" id="contactForm" onSubmit={handleSubmit} noValidate>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="name" className="form-label">Full Name</label>
                                        <input type="text" className="form-control" id="name" placeholder="Isaac.." value={formData.name} onChange={handleChange} autoComplete='name' required />
                                        <p className="text-danger small">{errors.name}</p>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="email" className="form-label">Email Address</label>
                                        <input type="email" className="form-control" id="email" placeholder="isaac@example.com" value={formData.email} onChange={handleChange} autoComplete='email' required />
                                        <p className="text-danger small">{errors.email}</p>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="subject" className="form-label">Subject</label>
                                    <input type="text" className="form-control" id="subject" placeholder="How can we help?" value={formData.subject} onChange={handleChange} required />
                                    <p className="text-danger small">{errors.subject}</p>
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="message" className="form-label">Your Message</label>
                                    <textarea className="form-control" id="message" rows={5} placeholder="Write your message here..." value={formData.message} onChange={handleChange} required></textarea>
                                    <p className="text-danger small">{errors.message}</p>
                                </div>
                                <div className="text-right">
                                    <button className="btn btn-custom w-100 py-3" type="submit" id="sendMessageButton">Send Message ↗</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactForm;
